/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import * as Radix from '@radix-ui/themes';

import { use } from 'fierry/react';

import { usePreference } from 'solis/preferences';

import Galaxy from 'solis/application/galaxy';

import { colorAt } from 'solis/theme/palette';

import useSystemAppearance from 'solis/theme/system';


const Theme = {};


const useAppearance = () =>
{
  const system = useSystemAppearance();

  return usePreference('appearance') ?? system;
};


export const useAccent = () =>
{
  const galaxy = use(Galaxy);

  const account = galaxy?.getCurrentAccount();

  return account ? colorAt(account.cass.theme) : 'gray';
};


Theme.Export = ({ children }) =>
(
  <Radix.Theme appearance = {useAppearance()} accentColor = {useAccent()} children = {children} />
);


export default Theme;
